import React from "react";
import { MenuIconButton, MenuIconButtonProps } from "../../../../Buttons/MenuIconButton/MenuIconButton";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { StopPropagation } from "../../../../StopPropagation/StopPropagation";
import { OperationalContent } from "../../shared/OperationalContent";
import { menuItemsPadding } from "../../shared/styles";
import { FinalColumnProps } from "../shared/props";
import { getFinalColumnContent } from "../shared/utils";

export interface BaseActionMenuFinalColumnProps {
    /**
     * MenuIconButtonProps to render a MenuIconButton component at the far right of the column (LTR).
     */
    readonly menuProps: MenuIconButtonProps;
}

export type ActionMenuFinalColumnProps = FinalColumnProps & BaseActionMenuFinalColumnProps;

export const ActionMenuFinalColumn: React.FC<ActionMenuFinalColumnProps> = ({
    menuProps,
    disabled,
    operationalData,
    ...otherProps
}) => (
    <Stack horizontal={true} horizontalAlign="space-between" verticalAlign="center">
        <Stack>
            <OperationalContent
                operationalData={operationalData}
            >
                {getFinalColumnContent(otherProps, disabled)}
            </OperationalContent>
        </Stack>
        <StopPropagation>
            <MenuIconButton
                {...menuProps}
                disabled={disabled}
                menuItemsPadding={menuItemsPadding}
            />
        </StopPropagation>
    </Stack>
);
